"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var DealerDetails_1 = require("./DealerDetails");
var DealerDetailsWrapper = function (_a) {
    var dealerDetails = _a.dealerDetails;
    var _b, _c, _d, _e;
    return (dealerDetails && (<>
        <DealerDetails_1.default name={(_b = dealerDetails) === null || _b === void 0 ? void 0 : _b.name} streetName={(_c = dealerDetails) === null || _c === void 0 ? void 0 : _c.address} city={(_d = dealerDetails) === null || _d === void 0 ? void 0 : _d.city} postCode={(_e = dealerDetails) === null || _e === void 0 ? void 0 : _e.postCode}/>
      </>));
};
exports.default = DealerDetailsWrapper;
